import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { NativeProps } from '@/src/components/interfaces';

export type CBoxElement = 'div' | 'aside' | 'section' | 'article' | 'main' | 'nav' | 'header' | 'footer';

export interface CBoxProps extends NativeProps {
  fullWidth?: boolean;
  fullHeight?: boolean;
  as?: CBoxElement;
}

export function CBox(props: PropsWithChildren<CBoxProps>): React.JSX.Element {
  const Tag = props.as ?? 'div';

  return (
    <Tag
      className={classNames('c-box', {
        'c-box--full-width': props.fullWidth,
        'c-box--full-height': props.fullHeight,
      }, props.class)}
      id={props.id}
      data-test-selector={props.testSelector}
    >
      {props.children}
    </Tag>
  );
}